<template>
  <div class="table-container">
    <a-table class="stripped table-hover" :columns="visibleCloumns" :data-source="data" :pagination="false"
      :row-selection="data.length ? rowSelection : null" @change="handleTableSortChange">
      <!-- Template for table body cells -->
      <template #headerCell="{ column }">
        <span draggable="true" @dragstart="dragStart(column.key)" @dragover.prevent @drop="drop(column.key)" style="cursor: grab;display: block;
    padding: 0 10px;">
          {{ column.title }}
        </span>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'org_name'">
          <h2 class="table-avatar d-flex align-items-center">
            <router-link
              :to="{ path: '/crm/organisation-details', query: { ter_Id: record.territory_id, org_Id: record.organization_id } }"
              class="profile-split d-flex flex-column">
              {{ record.org_name }}
            </router-link>
          </h2>
        </template>
        <template v-else-if="column.key === 'org_status'">
          <div>
            <span>{{ record.org_status }}</span>
          </div>
        </template>
        <template v-else-if="column.key === 'org_responsible'">
          <div>
            <span class="text-capitalize">{{ record.org_responsible }}</span>
          </div>
        </template>
        <!-- <template v-else-if="column.key === 'Phone'">
      <div>
        {{ record.phone }}
      </div>
    </template> -->
        <template v-else-if="column.key === 'action'">
          <div class="icon-field">

            <router-link :to="{ path: '/crm/create-organisation', query: { org_Id: record.organization_id } }"
              title="Edit" class="btn table_action_btn"><i class="ti ti-edit"></i> Edit</router-link>

            <!-- <router-link :to="{ path: '/crm/create-person', query: { org_Id: record.key } }" class="btn table_action_btn ms-2"><i class="ion-person"></i>  Add Person</router-link> -->
          </div>

        </template>
      </template>
    </a-table>
  </div>

  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal-backdrop fade show" v-if="showDeleteModal"></div>
  <div v-if="showDeleteModal" class="modal custom-modal fade show" style="display: block;" tabindex="-1" role="dialog"
    aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" @click="showDeleteModal = false" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="success-message text-center">
            <div class="success-popup-icon">
              <i class="ti ti-trash-x"></i>
            </div>
            <h3>Delete Account</h3>
            <p class="del-info">Are you sure you want to delete?</p>
            <div class="col-lg-12 text-center modal-btn">
              <button class="btn btn-light" @click="showDeleteModal = false">Cancel</button>
              <button class="btn btn-danger" @click="deleteOrganisation(selectedUserId)">Yes, Delete it</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watchEffect,
  computed,
  watch
} from 'vue';
import {
  useStore
} from "vuex";
import {
  useRouter
} from 'vue-router';
import apiClient from '@/axios';

export default {
  props: {
    searchQuery: String,
    filters: Object,
    columnOptions: Array,
    selectedColumns: Array,
  },
  data() {
    return {
      // columns,
      data: [],
      selectedUserId: null,
      showDeleteModal: false,
      rowSelection: {
        onChange: () => { },
        onSelect: () => { },
        onSelectAll: () => { },
      },
    };
  },

  setup(props) {
    const store = useStore();
    const router = useRouter();
    const data = ref([]);
    const column = ref([]);
    const module_data = ref([])
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const sorter = ref({
      key: "", // Default sort key
      order: "", // Default order
    });
    let draggedColumnKey = null;
    const visibleCloumns = ref([])

    const dragStart = (key) => {
      draggedColumnKey = key;
    };

    const drop = (targetKey) => {
      if (draggedColumnKey !== targetKey) {
        const oldIndex = visibleCloumns.value.findIndex(col => col.key === draggedColumnKey);
        const newIndex = visibleCloumns.value.findIndex(col => col.key === targetKey);
        const movedColumn = visibleCloumns.value.splice(oldIndex, 1)[0];
        visibleCloumns.value.splice(newIndex, 0, movedColumn);
        saveFieldOrder();
      }
    };

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const fetchOrganisations = async (page) => {
      if (typeof page === 'number' && Number.isFinite(page)) {
        pagination.value.current = page;
      }
      const params = {
        search: props.searchQuery,
        status: props.filters.status,
        // vat_group: props.filters.vatGroup,
        www: props.filters.www,
        fax: props.filters.fax,
        // telephone: props.filters.telephone,
        page: pagination.value.current,
        pageSize: pagination.value.pageSize,
        sort_field: sorter.value.key,
        sort_order: sorter.value.order,
      };
      const response = await store.dispatch('organisation/fetchOrgLists', params);
      if (response.data) {
        // data.value = response.data.map((fields) => {
        //   return fields.fields
        // });

        data.value = response.data.map((item) => {
          const formattedFields = {}

          for (const [key, value] of Object.entries(item.fields)) {
            if (typeof value === 'string' && value.trim() !== '') {
              if (value === value.toLowerCase()) {
                // Only convert if value is all lowercase
                formattedFields[key] = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
              } else {
                formattedFields[key] = value // leave as is
              }
            } else {
              formattedFields[key] = value // preserve null, numbers, etc.
            }
          }

          return formattedFields
        })

        const moduleId = response?.module_id;

        if (props.selectedColumns?.length === 0 && props.selectedColumns?.value?.length === undefined) {
          await fetchModuleData(moduleId)
        }


        let dynamicColumns = []

        if (module_data.value?.length > 0) {
          module_data.value.map((org) => {
            return org.children.map((item) => {
              const label = org.label.substr(0, 1).toUpperCase() + org.label.substr(1, 2);
              const itemLabel = item.label.substr(0, 1).toUpperCase() + item.label.substr(1);
              dynamicColumns.push({
                label: `${org.label.substr(0, 1).toUpperCase() + org.label.substr(1)}: ${item.label.substr(0, 1).toUpperCase() + item.label.substr(1)}`,
                title: `${label}. ${itemLabel}`,
                field: item.field,
                dataIndex: item.field,
                key: item.field,
                // sorter: (a, b) => a[item.field]?.toString().localeCompare(b[item.field]?.toString()),
                sorter: (a, b) => {
                  const aValue = a[item.field];
                  const bValue = b[item.field];

                  if (!aValue || !bValue) return 0;

                  // Numeric sort
                  if (!isNaN(aValue) && !isNaN(bValue)) {
                    return Number(aValue) - Number(bValue);
                  }

                  const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
                  const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

                  if (isoDateRegex.test(aValue) && isoDateRegex.test(bValue)) {
                    return new Date(aValue).getTime() - new Date(bValue).getTime();
                  }

                  if (ddMmYyyyRegex.test(aValue) && ddMmYyyyRegex.test(bValue)) {
                    const parseDate = (dateStr) => {
                      const [day, month, year] = dateStr.split('/').map(Number);
                      return new Date(year, month - 1, day);
                    };

                    return parseDate(aValue).getTime() - parseDate(bValue).getTime();
                  }

                  // Default string sort
                  return aValue.toString().localeCompare(bValue.toString());
                }

              })

            });
          })

          // Ensure the "Action" column is always at the end
          dynamicColumns.push({
            title: "Action",
            label: "Action",
            dataIndex: "Action",
            key: "action",
            // fixed: "right", width: 200
          });

          column.value = dynamicColumns;

          const columnKeys = [
            "org_unique_code",
            "org_name",
            "org_postcode",
            "org_responsible",
            "org_fax",
            "org_www",
            "org_territory_id",
            "org_status",
            "org_no_of_employees",
          ];

          // Filter and maintain order as per columnKeys
          const prioritizedColumns = columnKeys
            .map(key => dynamicColumns.find(col => col.key === key))
            .filter(Boolean); // Remove undefined values if any key is not found

          const otherColumns = dynamicColumns.filter(col => !columnKeys.includes(col.key));

          // Merge prioritized columns first, then others
          const orderedColumns = [...prioritizedColumns, ...otherColumns];

          // Assign the ordered columns to columnOptions
          props.columnOptions.value = orderedColumns
            .filter(col => col.key !== "action") // Exclude 'action' column
            .map(col => ({
              label: col.label,
              value: col.key,
            }));

          if (props.selectedColumns?.length === 0 && visibleCloumns.value.length === 0 && props.selectedColumns?.value?.length === undefined) {
            props.selectedColumns.value = props.columnOptions.value
              .slice(0, 6)
              .map(option => option.value);
          } else {
            props.selectedColumns.value = visibleCloumns.value
              .map((option) => option.key);
          }

        }

        pagination.value.total = response.total;
      }
    };

    const fetchModuleData = async (id) => {
      try {
        // const data = await store.dispatch("report/fetchModuleData", id);
        const response = await apiClient.get(`/report/module/${id}/fields?type=filters`);
        if (response.data.status) {
          const groups = response.data.data || [];
          // Prefer the requested organisations module (not person, which may appear first if unordered).
          const primary =
            groups.find((g) => g.id === id) ||
            groups.find((g) => String(g.label || '').toLowerCase() === 'organisations') ||
            groups[0];
          module_data.value = primary ? [primary] : [];
        }
      }
      catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    const handleTableChange = (current, pageSize, sort) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchOrganisations();
    };

    const handleTableSortChange = (page, filters, sort) => {
      if (sort?.order) {
        sorter.value.key = sort.columnKey;
        sorter.value.order =
          sort.order === "ascend" ? "ASC" : sort.order === "descend" ? "DESC" : "";
      } else {
        sorter.value.key = '';
        sorter.value.order = "";
      }

      fetchOrganisations();
    };

    const saveFieldOrder = async () => {
      const payload = {
        form_key: 'organisation_listing',
        fields_json: visibleCloumns.value
      }
      const response = await store.dispatch("opportunity/changeColumns", payload)
    };

    watch(
      () => props.selectedColumns.value,
      (newVal, oldProps) => {
        let selectedCols =
          !newVal || newVal.length === 0
            ? column.value
            : newVal
              .map((key) => column.value.find((col) => col.key === key))
              .filter(Boolean);

        // Ensure "action" column is always included
        const actionColumn = column.value.find((col) => col.key === "action");
        if (actionColumn && !selectedCols.some((col) => col.key === "action")) {
          selectedCols.push(actionColumn);
        }

        // Build a Set of selected keys for fast lookup
        if (visibleCloumns.value.length > 0) {
          const selectedKeys = new Set(selectedCols.map(col => col.key));

          // Remove columns not in selectedCols (except "action")
          visibleCloumns.value = visibleCloumns.value.filter(
            col => selectedKeys.has(col.key) || col.key === "action"
          );

          // Add missing columns at the end
          const visibleKeys = new Set(visibleCloumns.value.map(col => col.key));
          const newExtraCols = selectedCols.filter(col => !visibleKeys.has(col.key));

          visibleCloumns.value.push(...newExtraCols);

          if (oldProps) {
            saveFieldOrder();
          }
        }
        else {
          visibleCloumns.value = [...selectedCols];
        }
      },
      { immediate: true, deep: true }
    );


    // watchEffect(() => {
    //   fetchOrganisations();
    // });

    const fetchColumns = async () => {
      const res = await store.dispatch("opportunity/getColumnsData", 'organisation_listing');
      if (res.data && Object.keys(res.data).length > 0) {
        const fields = res.data.fields_json;

        visibleCloumns.value = fields.map(item => ({
          ...item,
          sorter: (a, b) => {
            const aValue = a[item.field];
            const bValue = b[item.field];

            if (!aValue || !bValue) return 0;

            // Check if value is a valid number
            if (!isNaN(aValue) && !isNaN(bValue)) {
              return Number(aValue) - Number(bValue);
            }

            const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
            const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

            if (isoDateRegex.test(aValue) && isoDateRegex.test(bValue)) {
              return new Date(aValue).getTime() - new Date(bValue).getTime();
            }

            if (ddMmYyyyRegex.test(aValue) && ddMmYyyyRegex.test(bValue)) {
              const parseDate = (dateStr) => {
                const [day, month, year] = dateStr.split('/').map(Number);
                return new Date(year, month - 1, day);
              };

              return parseDate(aValue).getTime() - parseDate(bValue).getTime();
            }

            // Default to string sorting
            return aValue.toString().localeCompare(bValue.toString());
          }
        }));
      }
    };

    onMounted(async () => {
      await fetchColumns()
    })

    return {
      data,
      pagination,
      fetchOrganisations,
      handleTableChange,
      dragStart,
      drop,
      column,
      fetchModuleData,
      module_data,
      // filteredColumns,
      pageSizeOptions,
      visibleCloumns,
      saveFieldOrder,
      fetchColumns,
      handleTableSortChange,
      sorter
    };
  },
};
</script>
<!-- <style>
.table-container {
  max-height: 100%, ;
  overflow-y: scroll;
  margin-bottom: 25px;
}

.table-container::-webkit-scrollbar {
  width: 0;
}

.pagination-container {
  display: flex;
  justify-content: end;
  margin-top: 10px;
  text-align: center;
}
</style> -->
